import UserProfile from './UserProfile';

export default function ProfileTab({ auth }) {
  return <UserProfile userId={auth.user.id} auth={auth} isOwnProfile={true} />;
}